import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class QrPaymentRedirectServiceService {

  constructor(private readonly http: HttpClient) {}

  generatePaymentQR(bookingId: string, xpcnId: string) {
    return this.http.get(
      environment.coreApiUrl + 'api/v2/Generate-Payment-QR?bookingId=' + bookingId + '&XpcnId=' + xpcnId
    );
  }
}
